export default __webpack_public_path__ + "static/media/NBA.9bb32d5f.jpg";